import React from 'react'

import { FormFieldStatus, InputField, SelectField } from '@gousto-internal/citrus-react'
import { Field, FieldProps } from 'formik'

import { checkoutConstants } from 'routes/Checkout/checkoutConstants'

const leaveBoxOptions = checkoutConstants.leaveBoxOptions.map((option) => ({
  value: option,
  label: option,
}))

export const DeliveryInstruction = () => (
  <>
    <Field name="deliveryInstruction">
      {({ field: selectField, meta: selectMeta }: FieldProps) => (
        <>
          <SelectField
            id={selectField.name}
            data-testid="checkoutDeliveryDetailsInstruction"
            label="Where can we leave your box if you're not in?"
            status={selectMeta.touched && selectMeta.error ? FormFieldStatus.Error : undefined}
            validationMessage={selectMeta.touched ? selectMeta.error : undefined}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...selectField}
          >
            {leaveBoxOptions.map((option) => (
              <option
                key={option.value}
                value={option.value}
                selected={selectField.value === option.value}
              >
                {option.label}
              </option>
            ))}
          </SelectField>

          {checkoutConstants.leaveBoxOptionsWithMessage.includes(selectField.value) && (
            <Field name="deliveryInstructionCustom">
              {({ field: customField, meta: customMeta }: FieldProps) => (
                <InputField
                  id={customField.name}
                  data-testid="checkoutDeliveryDetailsInstructionCustom"
                  label={undefined}
                  placeholder={
                    selectField.value === 'Neighbour'
                      ? 'e.g. next door at number 10'
                      : 'e.g. lockbox around left side of house'
                  }
                  status={
                    customMeta.touched && customMeta.error ? FormFieldStatus.Error : undefined
                  }
                  validationMessage={customMeta.touched ? customMeta.error : undefined}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...customField}
                />
              )}
            </Field>
          )}
        </>
      )}
    </Field>
  </>
)
